/**
 * Utility per il calcolo dell'URL delle immagini di prodotti/combo.
 * - Se imageId è presente: URL diretto su Cloud Storage.
 * - Altrimenti: path sotto public (/images/<projectId>/items/<id>.jpg).
 */

const projectId = process.env.REACT_APP_PROJECT_ID;

const firebaseConfig = require(`../api/config/${projectId}.json`);
const storageBucket = firebaseConfig.storageBucket;

/**
 * Base URL per le risorse statiche in public.
 * @returns {string} es. /images/popular-canterano
 */
export function getPublicImageBaseUrl() {
  return `/images/${projectId}`;
}

/**
 * URL dell'immagine di un prodotto o combo.
 * @param {Object} opts
 * @param {string} [opts.imageId] - Se presente usa Cloud Storage
 * @param {string} opts.id - ID prodotto/combo (usato per fallback public)
 * @param {'product'|'combo'} opts.kind
 * @param {string} [opts.query] - Query string da appendere (es. ?v=123 per cache bust)
 * @returns {string}
 */
function appendQuery(url, query) {
  if (!query) return url;
  const q = query.replace(/^\?/, '');
  return q ? `${url}?${q}` : url;
}

export function getMenuImageUrl({ imageId, id, kind, query = '' }) {
  if (imageId) {
    const path = `menu-images/${kind}/${encodeURIComponent(imageId)}.jpg`;
    return appendQuery(`https://storage.googleapis.com/${storageBucket}/${path}`, query);
  }
  return appendQuery(`${getPublicImageBaseUrl()}/items/${id}.jpg`, query);
}

/**
 * URL dell'immagine placeholder (sempre da public).
 * @returns {string}
 */
export function getMenuImagePlaceholderUrl() {
  return `${getPublicImageBaseUrl()}/placeholder.png`;
}
